import { useNavigate } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  MenuItem,
  SelectChangeEvent,
  Select,
  Tabs,
  Tab,
  IconButton,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import React from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const tabLabels = ["Pending", "Ongoing", "Upcoming", "Cancelled", "Completed"];

const BookingRequests = () => {
  const navigate = useNavigate();

  const [rows] = useState([
    {
      id: "B001",
      customerName: "John Doe",
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      serviceDetails: "Hair Color",
      dateTime: "2025-08-22 10:00 AM - 12:00 PM",
      notes: "Bring extra tools",
      customerAddress: "123 Main Street, City",
      providerAddress: "456 Service Lane, City",
      providerDetails: "Hair Razors",
      price: "AED 200",
      type: "In-Home",
      cancelledBy: "Admin",
      cancelledOn: "2025-08-20 05:45 PM",
      cancellationReason: "Customer requested to reschedule",
    },
    {
      id: "B002",
      customerName: "Jane Smith",
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      serviceDetails: "Hair Wash",
      dateTime: "2025-08-23 2:00 PM - 4:00 PM",
      notes: "Wash with good shampoo",
      customerAddress: "789 Green Park, City",
      providerAddress: "321 Water Street, City",
      providerDetails: "Salon Elegance",
      price: "AED 300",
      type: "In-Store",
      cancelledBy: "User",
      cancelledOn: "2025-08-20 05:45 PM",
      cancellationReason: "Emergency at customer’s end",
    },
  ]);

  const columns = [
    { id: "id", label: "Booking ID" },
    { id: "customerName", label: "Customer Details" },
    { id: "serviceDetails", label: "Service Details" },
    { id: "dateTime", label: "Selected Date & Time Slot" },
    { id: "notes", label: "Notes" },
    { id: "price", label: "Total Price" },
    { id: "customerAddress", label: "Customer Address" },
    { id: "providerAddress", label: "Service Provider Address" },
    { id: "providerDetails", label: "Service Provider Details" },
    { id: "type", label: "Type" },
    { id: "status", label: "Status" },
    { id: "action", label: "Actions" },
  ];

  const [searchTerm, setSearchTerm] = useState("");
  const [Status, setStatus] = React.useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Manage Bookings</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage
          Bookings
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              {tabLabels.map((label, idx) => (
                <Tab key={label} label={label} {...a11yProps(idx)} />
              ))}
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </Box>
          </div>
        </div>

        {/* Tab Panels */}
        {tabLabels.map((_, tabIndex) => (
          <CustomTabPanel value={valueTabs} index={tabIndex} key={tabIndex}>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow hover>
                    {columns.map((col) => (
                      <TableCell key={col.id}>{col.label}</TableCell>
                    ))}
                    {tabIndex === 3 && (
                      <>
                        <TableCell>Cancelled By</TableCell>
                        <TableCell>Cancelled On</TableCell>
                        <TableCell>Cancellation Reason</TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .filter((row) =>
                      row.customerName
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    )
                    .map((row) => (
                      <TableRow hover key={row.id}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>
                          <div className="user_block click_action">
                            <figure>
                              <img
                                src="/static/images/user_placeholder.png"
                                alt=""
                              />
                            </figure>
                            <p>
                              <b>{row.name}</b>
                              <span>{row.email}</span>
                              <span>{row.phone}</span>
                            </p>
                          </div>
                        </TableCell>
                        <TableCell>{row.serviceDetails}</TableCell>
                        <TableCell>{row.dateTime}</TableCell>
                        <TableCell>{row.notes}</TableCell>
                        <TableCell>{row.price}</TableCell>
                        <TableCell>{row.customerAddress}</TableCell>
                        <TableCell>{row.providerAddress}</TableCell>
                        <TableCell>{row.providerDetails}</TableCell>
                        <TableCell>{row.type}</TableCell>
                        <TableCell>
                          <div className="form">
                            <Select
                              fullWidth
                              value={Status}
                              onChange={handleStatusChange}
                            >
                              <MenuItem disabled value="default">
                                Select Status
                              </MenuItem>
                              <MenuItem value="Pending">Pending</MenuItem>
                              <MenuItem value="Accept">Accept</MenuItem>
                              <MenuItem value="Completed">Completed</MenuItem>
                              <MenuItem value="Cancelled">Cancelled</MenuItem>
                            </Select>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="table_actions v2">
                            <Box>
                              <IconButton
                                onClick={() =>
                                  navigate("/manage-bookings/view", {
                                    state: { tabStatus: tabLabels[valueTabs] },
                                  })
                                }
                              >
                                <img
                                  src="/static/images/eye_icon.svg"
                                  alt="View"
                                />
                              </IconButton>
                            </Box>
                            <Box>
                              <IconButton>
                                <img
                                  src="/static/images/trash2_icon.svg"
                                  alt="Delete"
                                />
                              </IconButton>
                            </Box>
                          </div>
                        </TableCell>

                        {tabIndex === 3 && (
                          <>
                            <TableCell>{row.cancelledBy || "User"}</TableCell>
                            <TableCell>{row.cancelledOn || "-"}</TableCell>
                            <TableCell>
                              {row.cancellationReason || "-"}
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
        ))}
      </div>
    </>
  );
};

export default BookingRequests;
